import React from 'react';
import { motion } from 'framer-motion';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';

const { FiCheck, FiStar, FiHeart, FiTarget } = FiIcons;

const ProgressCelebration = ({ completedSections, totalSections, authorName }) => {
  const progressPercentage = (completedSections / totalSections) * 100;
  
  const celebrations = [
    { threshold: 20, message: "Great start! You're stewarding your gift well.", icon: FiHeart },
    { threshold: 40, message: "You're making excellent progress! Keep going.", icon: FiTarget },
    { threshold: 60, message: "More than halfway there! Your dedication shows.", icon: FiStar },
    { threshold: 80, message: "Almost complete! Your book plan is taking shape beautifully.", icon: FiCheck },
    { threshold: 100, message: "Congratulations! Your book plan is complete and ready!", icon: FiStar }
  ];

  const currentCelebration = celebrations
    .reverse()
    .find(celebration => progressPercentage >= celebration.threshold);

  if (!currentCelebration || progressPercentage < 20) return null;

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.9 }}
      animate={{ opacity: 1, scale: 1 }}
      className="bg-gradient-to-r from-sage-green/10 to-soft-blue/10 rounded-lg p-4 mb-6 border border-sage-green/30"
    >
      <div className="flex items-center space-x-3">
        <motion.div
          initial={{ scale: 0 }}
          animate={{ scale: 1 }}
          transition={{ delay: 0.2, type: "spring", stiffness: 200 }}
          className="bg-sage-green/20 rounded-full p-2"
        >
          <SafeIcon icon={currentCelebration.icon} className="text-sage-green" />
        </motion.div>
        <div className="flex-1">
          <p className="text-warm-brown font-medium">
            {authorName ? `${authorName}, y` : 'Y'}ou're doing amazing!
          </p>
          <p className="text-warm-brown/70 text-sm">
            {currentCelebration.message}
          </p>
        </div>
        <div className="text-right">
          <div className="text-2xl font-serif text-sage-green">
            {Math.round(progressPercentage)}%
          </div>
          <div className="text-xs text-warm-brown/60">Complete</div>
        </div>
      </div>
      
      <div className="mt-3">
        <div className="w-full bg-warm-brown/10 rounded-full h-2">
          <motion.div
            className="bg-gradient-to-r from-sage-green to-soft-blue h-2 rounded-full"
            initial={{ width: 0 }}
            animate={{ width: `${progressPercentage}%` }}
            transition={{ duration: 1, ease: "easeOut" }}
          />
        </div>
      </div>
    </motion.div>
  );
};

export default ProgressCelebration;